import { getRecentNotifications, markAllNotificationsRead } from '@/api'
import { filter } from 'lodash'

const state = {
  notifications: [],
  countUnread: null
}

const getters = {
  getNotifications: (state) => state.notifications,
  countUnreadNotifications: (state) => state.countUnread
}

const mutations = {
  setNotifications: (state, notifications) => state.notifications = notifications,
  setCountUnread: (state, count) => state.countUnread = count,
  decrementUnread: (state) => state.countUnread--,
  addNotification(state, notification) {
    state.notifications.unshift(notification)
    if (!notification.read_at) {
      state.countUnread++
    }
  }
}

const actions = {
  loadNotifications ({ commit, state }, userId) {
    getRecentNotifications(userId).then((response) => {
      commit('setNotifications', response.data.data)
      commit('setCountUnread', response.data.meta.unread)
    })
  },
  markAllAsRead ({ commit, state }, userId) {
    markAllNotificationsRead(userId).then(() => {
      commit('setCountUnread', 0)
    })
  },
  markAsRead ({ commit, state }, notification) {
    // TODO: actual API call
    commit('decrementUnread')
  },
  markAsUnread ({ commit, state }, notification) {
    // TODO: actual API call
    commit('incrementUnread')
  }
}


export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}